// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".index-module__container--219tI{border:1px solid #1e54b7;border:1px solid rgba(30,84,183,.1);box-shadow:3px 6px 25px rgba(0,0,0,.1)}.fade-appear{opacity:0}.fade-appear-done{opacity:.5;transition:opacity .25s}.fade-exit{opacity:.5;transform:translate3d(0)}.fade-exit-active{opacity:0;transition:opacity .25s}", ""]);
// Exports
exports.locals = {
	"container": "index-module__container--219tI"
};
module.exports = exports;
